import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section className="px-4 md:px-8 py-24 md:py-40 bg-background-50 min-h-[60vh] flex items-center justify-center">
      <div className="max-w-xl text-center">
        <div className="inline-flex items-center gap-2 mb-4 px-3 py-1 rounded-full bg-background-100 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
          <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
          404 — Página não encontrada
        </div>
        <h1 className="text-4xl md:text-6xl font-heading font-semibold tracking-tight text-foreground-950 leading-tight">
          Ops! Essa página não existe.
        </h1>
        <p className="mt-4 text-foreground-600">
          Vamos te levar de volta para o cardápio ou para a página inicial.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full bg-primary-950 text-background-50 text-sm font-semibold hover:bg-primary-900 transition-colors cursor-pointer whitespace-nowrap"
          >
            Página Inicial
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/cardapio"
            className="inline-flex items-center gap-2 px-5 py-3.5 rounded-full border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
          >
            Ver Cardápio
            <i className="ri-arrow-right-up-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}